import { css } from 'styled-components';
import { buttonResetMixin } from '../buttonResetMixin';
import { focusMixin } from '../focusMixin';
export var UnstyledButtonMixin = /*#__PURE__*/css(["", " ", ""], buttonResetMixin, focusMixin);